import { $http, $httpAuth } from '@/services/http-common'

export default {
  createOrganizationPage (title, organizationId, connectionId) {
    return $httpAuth.post(`/api/organizations/${organizationId}/connections/${connectionId}/pages`, {
      title
    })
  },
  getPageBySlug (slug) {
    return $http.get(`/api/pages/${slug}`)
  }
}
